module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Scenario {number} fra steg {stepNumber}","fromStep":"Fra steg {number}"},"en":{"title":"Scenario {number} from step {stepNumber}","fromStep":"From step {number}"}}')
  delete Component.options._Ctor
}
